import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  fetchFormList
} from 'apps/web_forms/slices/appSlice';
import { APP_ROUTES } from 'apps/web_forms/utils/constants';
import { useDispatch } from 'react-redux';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

function useFormsMetadata() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { formList } = useGlobalSelector();
  const [forms, setForms] = useState([]);
  const [loading, setLoading]= useState();
  const [error, setError]= useState();

  useEffect(() => {
    dispatch(fetchFormList());
  }, []);

  useEffect(() => {
    if (formList.loading !== loading) {
      setLoading(formList.loading);
    }

    if (formList.data && formList.data !== forms) {
      setForms(formList.data);
    }

    if (formList.error) {
      setError(formList.error);
      // TODO: Integrate Bugsnag to log the errors in prod.
      // eslint-disable-next-line no-console
      console.error('Error fetching forms', formList.error);
      history.push(APP_ROUTES.getErrorPageByCode(500));
    }
  }, [formList]);

  return {forms, loading, error };
}

export { useFormsMetadata };
